import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { DialogService } from '@progress/kendo-angular-dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import Swal from 'sweetalert2';

export interface ICanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({ providedIn: 'root' })
export class CanDeactivateGuard implements CanDeactivate<ICanComponentDeactivate> {
  public canDeactivateTab = true;
  private readonly discardClicked: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(private readonly dialogService: DialogService) {}

  get discardClickedListener() {
    return this.discardClicked.asObservable();
  }

  canDeactivate(
    component: ICanComponentDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.canDeactivateTab) {
      return true;
    } else {
      return this.canDeactivatePopupTab().then(res => {
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            this.canDeactivateTab = res;
            resolve(res);
          }, 20);
        });
      });
    }
  }

  public async canDeactivatePopupTab(): Promise<boolean> {
    return Swal.fire({
      title: 'Unsaved Changes!',
      text: 'You have unsaved changes on this page. Please click Cancel to return to the page or Continue to discard changes.  ',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Discard Changes',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      allowEscapeKey: true
    }).then(result => {
      if (result.value) {
        this.discardClicked.next('Discard Clicked');

        return true;
      } else {
        return false;
      }
    });
  }

  /**
   * Discard Changed warning message for any given component on the setting dialog
   */
  public async discardWarningMessage(msg: string): Promise<boolean> {
    return this.dialogService
      .open({
        title: '',
        content: 'You are about to discard the ' + msg + ' changes you have made',
        actions: [{ text: 'Cancel' }, { text: 'Discard', primary: true }]
        // width: 450,
        // height: 200,
        // minWidth: 250
      })
      .result.toPromise()
      .then(res => {
        // console.dir(res);
        // @ts-ignore
        if (res.text === 'Discard') {
          this.discardClicked.next('Discard Clicked');
          return true;
        } else {
          return false;
        }
      });
  }
  /**
   * Deleting a Tab from the Product Setup page
   */
  // public async canDeleteSheetTab(msg: string): Promise<boolean> {
  //   const promise: Promise<boolean> = new Promise<boolean>((resolve, reject) => {
  //     Swal.fire({
  //       title: 'You are about to delete the ' + msg + '\n This will permanently delete the tab and all associated products.',
  //       text: 'Please click cancel to return to the page or continue to delete the chosen Product setup tab.',
  //       type: 'warning',
  //       showCancelButton: true,
  //       confirmButtonText: 'Continue',
  //       cancelButtonText: 'Cancel',
  //       reverseButtons: true,
  //       allowEscapeKey: true
  //     })
  //       .then(result => {
  //         if (result && result.value) {
  //           resolve(true);
  //         } else {
  //           resolve(false);
  //         }
  //       })
  //       .catch(err => {
  //         reject(true);
  //       });
  //   });

  //   return promise;
  // }
}
